<template>
  <thead :class="['applicant-table-header', { 'has-review-date': showReviewListDate }]">
    <tr>
      <!-- Checkbox Column -->
      <th v-if="showCheckbox" class="col-checkbox text-center">
        <input
          type="checkbox"
          v-model="checkAllModel"
          @change="onCheckAllChange"
          style="width: 18px;height: 18px;margin-left: 5px;"
        />
      </th>

      <!-- Spacer -->
      <th class="col-spacer"></th>

      <template>
        <!-- Review List Added Date (Optional) -->
        <th
          v-if="showReviewListDate"
          v-on:click="sorting('reviewListAddedDate')"
          class="col-review-date text-center"
          :class="{ 'arrow-link': !disableSort }"
          data-testid="review-list-date-header"
        >
          {{ 'リスト振分日' }}
          <template v-if="!disableSort">
            <i
              class="fa fa-long-arrow-up"
              :class="{ active: isReviewListDateAscActive }"
              aria-hidden="true"
            ></i>
            <i
              class="fa fa-long-arrow-down"
              :class="{ active: isReviewListDateDescActive }"
              aria-hidden="true"
            ></i>
          </template>
        </th>

        <!-- Joined/Updated Date -->
        <th
          v-on:click="sorting('joinedDate')"
          class="col-joined-date text-center"
          :class="{ 'arrow-link': !disableSort }"
          data-testid="joined-date-header"
        >
          {{ joinedDateLabel }}
          <template v-if="!disableSort">
            <i
              class="fa fa-long-arrow-up"
              :class="{ active: isJoinedDateAscActive }"
              aria-hidden="true"
            ></i>
            <i
              class="fa fa-long-arrow-down"
              :class="{ active: isJoinedDateDescActive }"
              aria-hidden="true"
            ></i>
          </template>
        </th>

        <!-- Via (Source) -->
        <th class="col-via text-center" v-if="showViaFilter">
            <b-dropdown
              ref="companyDropdown"
              id="ddown-aria"
              text="経由"
              variant="primary"
              class="m-2 th-dropdown btn-plain-dv"
              @hidden="resetCompanySelection"
              @shown="$emit('overflow'); syncTempModels();"
              data-testid="via-dropdown"
            >
              <div>
                <div class="form-check">
                  <input
                    type="checkbox"
                    id="own"
                    value="own"
                    class="form-check-input"
                    v-model="tempCompanyModel"
                  />
                  <label class="form-check-label">自社HP経由</label>
                </div>
                <div class="form-check">
                  <input
                    type="checkbox"
                    id="other"
                    value="other"
                    class="form-check-input"
                    v-model="tempCompanyModel"
                  />
                  <label class="form-check-label">他ルート経由</label>
                </div>
                <div class="dropdown-separator"></div>
                <div class="dropdown-footer">
                  <button class="btn-sm btn-primary ok-button" @click="applyCompanyFilters">
                    OK
                  </button>
                </div>
              </div>
            </b-dropdown>
        </th>
        <th class="col-via text-center" v-else>
          経由
        </th>

        <!-- Scout Wish -->
        <th class="col-scout text-center" v-if="showScoutFilter">
          <b-dropdown
            ref="scoutDropdown"
            id="ddown-aria-scout"
            text="スカウト希望"
            variant="primary"
            class="m-2 th-dropdown btn-plain-dv"
            data-testid="scout-dropdown"
          >
            <div>
              <div class="form-check mb-1">
                <input
                  type="checkbox"
                  id="scout-pref-has"
                  class="form-check-input"
                  :checked="scoutHope === true"
                  @change="setScoutHope(scoutHope === true ? null : true)"
                />
                <label class="form-check-label" for="scout-pref-has">
                  〇
                </label>
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  id="scout-pref-none"
                  class="form-check-input"
                  :checked="scoutHope === false"
                  @change="setScoutHope(scoutHope === false ? null : false)"
                />
                <label class="form-check-label" for="scout-pref-none">
                  なし
                </label>
              </div>
            </div>
            <div class="dropdown-separator"></div>
            <div class="dropdown-footer">
              <button class="btn-sm btn-primary ok-button" @click.stop="applyScoutPreference">
                OK
              </button>
            </div>
          </b-dropdown>
        </th>
        <th class="col-scout text-center" v-else>
          スカウト希望
        </th>

        <!-- Name -->
        <th class="col-name text-center" data-testid="name-header">
          名前
        </th>

        <!-- Age -->
        <th
          class="col-age text-center"
          :class="{ 'arrow-link': !disableSort }"
          v-on:click="sorting('birth_date')"
          data-testid="age-header"
        >
          年齢
          <template v-if="!disableSort">
            <i
              class="fa fa-long-arrow-up"
              :class="{ active: sortKey === 'birth_date' && asc }"
              aria-hidden="true"
            ></i>
            <i
              class="fa fa-long-arrow-down"
              :class="{ active: sortKey === 'birth_date' && !asc }"
              aria-hidden="true"
            ></i>
          </template>
        </th>

        <!-- Graduation School -->
        <th class="col-graduation text-center">
          卒業学校名
        </th>

        <!-- Company -->
        <th class="col-company text-center">
          在籍企業
        </th>

        <!-- Recent Job (Occupation) -->
        <th class="col-job text-center" v-if="showJobFilter">
          <b-dropdown
            ref="jobDropdown"
            id="ddown-aria-job"
            text="直近職種"
            variant="primary"
            class="m-2 th-dropdown"
            @hidden="resetMainJobSelection"
            @shown="$emit('overflow'); syncTempModels();"
            data-testid="job-dropdown"
          >
            <div class="form-group row">
              <div class="col-md-12">
                <div class="ps-4" v-for="main in occupations" v-bind:key="main.id">
                  <input
                    type="checkbox"
                    :id="main.id"
                    :value="main.id"
                    class="form-check-input"
                    v-model="tempMainJobModel"
                    @change="handleTempMainJobChange"
                  />
                  <label class="form-check-label">{{main.title}}</label>
                </div>
              </div>
            </div>
            <div class="dropdown-separator"></div>
            <div class="dropdown-footer">
              <button class="btn-sm btn-primary ok-button" @click="applyMainJobFilters">
                OK
              </button>
            </div>
          </b-dropdown>
        </th>
        <th class="col-job text-center" v-else>
           直近職種
        </th>


        <!-- Income -->
        <th
          class="col-income text-center"
          :class="{ 'arrow-link': !disableSort }"
          v-on:click="sorting('last_year_income')"
          data-testid="income-header"
        >
          年収
          <template v-if="!disableSort">
            <i
              class="fa fa-long-arrow-up"
              :class="{ active: sortKey === 'last_year_income' && asc }"
              aria-hidden="true"
            ></i>
            <i
              class="fa fa-long-arrow-down"
              :class="{ active: sortKey === 'last_year_income' && !asc }"
              aria-hidden="true"
            ></i>
          </template>
        </th>

      </template>

      <!-- Memo -->
      <th class="col-memo text-center arrow-link" data-testid="memo-header">
        メモ
      </th>

      <!-- Status -->
        <th class="col-status text-center" v-if="showStatusFilter">
        <b-dropdown
          ref="statusDropdown"
          id="ddown-aria-status"
          text="登録者ステータス"
          variant="primary"
          class="m-2 th-dropdown"
          menu-class="status-dropdown-menu"
          @hidden="resetStatusSelection"
          @shown="$emit('overflow'); syncTempModels();"
        >
          <div>
            <div
              class="form-check form-check"
              v-for="(status, index) in clientStatus"
              v-bind:key="index"
            >
              <input
                type="checkbox"
                :id="index"
                :value="status"
                class="form-check-input"
                v-model="tempStatusModel"
              />
              <label class="form-check-label">{{status}}</label>
            </div>
            <div class="dropdown-separator"></div>
            <div class="dropdown-footer">
              <button class="btn-sm btn-primary ok-button" @click="applyStatusFilters">
                OK
              </button>
            </div>
          </div>
        </b-dropdown>
      </th>
       <th class="col-status text-center" v-else>
         登録者ステータス
       </th>

      <!-- Actions/Empty -->
       <!-- <th class="text-center">判定</th> -->
      <!-- <th class="col-actions text-center"></th> -->
    </tr>
  </thead>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import mutations from '@/config/mutations';

export default {
  name: 'ApplicantTableHeader',
  data() {
    return {};
  },
  props: {
    sortKey: {
      type: String,
      default: null
    },
    asc: {
      type: Boolean,
      default: true
    },
    clientStatus: {
      type: Array,
       default: () => [
        '未確認',
        '選考対象外',
        '選考対象、未対応',
        '確認中',
        '過去応募済み',
        'コンタクト済み',
        '返信有',
        '選考応募有',
        'システム取込み済み',
        '選考NG',
        '中長期的対応',
        'その他',
      ]
    },
    showStatusFilter: {
      type: Boolean,
      default: true
    },
    showJobFilter: {
      type: Boolean,
      default: true
    },
    showReviewListDate: {
      type: Boolean,
      default: false
    },
    joinedDateLabel: {
      type: String,
      default: '登録/更新日'
    },
    showCheckbox: {
      type: Boolean,
      default: true
    },
    showViaFilter: {
      type: Boolean,
      default: true
    },
    showScoutFilter: {
      type: Boolean,
      default: true
    },
    disableSort: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tempCompanyModel: [],
      tempMainJobModel: [],
      tempStatusModel: []
    };
  },
  computed: {
    ...mapGetters({
      getMainJobModel: 'getMainJobModel',
      getCompanyModel: 'getCompanyModel',
      getStatusModel: 'getStatusModel',
      isJdSearch: 'getIsJdSearch',
    }),
    ...mapState({
      selectors: ({ applicant }) => applicant.selectors,
      sortBy: ({ applicant }) => applicant.sortBy,
      isCheckAll: ({ applicant }) => applicant.isCheckAll,
      searchParams: ({ applicant }) => applicant.searchParams,
    }),
    occupations() {
      return this.selectors.occupations || [];
    },
    checkAllModel: {
      get() {
        return this.isCheckAll;
      },
      set(value) {
        // Handled by change event to avoid double mutation if needed, 
        // but v-model setter is good for two-way sync.
        // We will delegate to parent via event or store. 
        // Since parent uses store, we can use store mutation here if we want 
        // OR emit event. 
        // The original uses a local isCheckAll v-model but calls checkAll() method which updates store/local.
      }
    },
    companyModel: {
      get() {
        return this.getCompanyModel;
      },
      set(value) {
        this.setCompanyModel(value);
      },
    },
    scoutHope: {
      get() {
        return this.$store.getters.getScoutHope;
      },
      set(value) {
        this.setScoutHope(value);
      },
    },
    mainJobModel: {
      get() {
        return this.getMainJobModel;
      },
      set(value) {
        this.setMainJobModel(value);
      },
    },
    statusModel: {
      get() {
        return this.getStatusModel;
      },
      set(value) {
        this.setStatusModel(value);
      },
    },
     // Computed properties for active arrow states
    isJoinedDateAscActive() {
      // Logic from ApplicantList
      if (this.isJdSearch) {
        // Need clientSortBy passed prop if we want to support client side sort indication?
        // For now adhering to store sortBy
         return this.sortKey === 'joinedDate' && !this.asc; // Assuming parent passes correct sortKey/asc
      }
       return this.sortBy === 'joinedDate';
    },
    isJoinedDateDescActive() {
      if (this.isJdSearch) {
         return this.sortKey === 'joinedDate' && this.asc; 
      }
      return this.sortBy === '-joinedDate';
    },
    isReviewListDateAscActive() {
      return this.sortBy === 'reviewListAddedDate';
    },
    isReviewListDateDescActive() {
      return this.sortBy === '-reviewListAddedDate';
    }
  },
  methods: {
    ...mapMutations([
      'setCheckAll',
      'setCompanyModel',
      'setMainJobModel',
      'setStatusModel',
      'updateMainJobModel',
      'setScoutHope',
    ]),
    applyScoutPreference() {
      this.$refs.scoutDropdown.hide();
      this.$emit('search');
    },
    syncTempModels() {
      // Sync all temp models with actual values when dropdown opens
      this.tempCompanyModel = [...this.getCompanyModel];
      this.tempMainJobModel = [...this.getMainJobModel];
      this.tempStatusModel = [...this.getStatusModel];
    },
    applyCompanyFilters() {
      this.setCompanyModel([...this.tempCompanyModel]);
      if (this.$refs.companyDropdown && typeof this.$refs.companyDropdown.hide === 'function') {
        this.$refs.companyDropdown.hide();
      }
      this.$emit('search');
    },
    applyMainJobFilters() {
      this.setMainJobModel([...this.tempMainJobModel]);
      this.updateMainJobModel({ mainJobs: this.tempMainJobModel });
      if (this.$refs.jobDropdown && typeof this.$refs.jobDropdown.hide === 'function') {
        this.$refs.jobDropdown.hide();
      }
      this.$emit('search');
    },
    applyStatusFilters() {
      this.setStatusModel([...this.tempStatusModel]);
      if (this.$refs.statusDropdown && typeof this.$refs.statusDropdown.hide === 'function') {
        this.$refs.statusDropdown.hide();
      }
      this.$emit('search');
    },
    resetCompanySelection() {
      this.tempCompanyModel = [...this.getCompanyModel];
    },
    resetMainJobSelection() {
      this.tempMainJobModel = [...this.getMainJobModel];
    },
    resetStatusSelection() {
      this.tempStatusModel = [...this.getStatusModel];
    },
    handleTempMainJobChange() {
      // Update temp main job model when checkboxes change
    },
    onCheckAllChange() {
       this.$emit('check-all');
    },
    sorting(key) {
      if (this.disableSort) return;
      this.$emit('sort', key);
    },
    search() {
      this.$emit('search');
    },
    handleMainJobChange() {
       this.updateMainJobModel({mainJobs: this.mainJobModel});
    }
  }
};
</script>

<style>
/* Base table layout for consistent widths - applies globally */
.applicant-table-header {
  width: 100%;
  table-layout: fixed;
}

.applicant-table-header th {
  padding-top: 12px;
  padding-bottom: 12px;
  background-color: #fff;
  border-bottom: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.12);
}

/* Column width definitions - applies to all tables using this header */
.applicant-table-header .col-checkbox {
  width: 3%;
  min-width: 50px;
}

.applicant-table-header .col-spacer {
  width: 3%;
  min-width: 50px;
}

.applicant-table-header .col-review-date {
  width: 7%;
  min-width: 95px;
  white-space: nowrap;
}

.applicant-table-header .col-joined-date {
  width: 8%;
  min-width: 135px;
  white-space: nowrap;
}

.applicant-table-header .col-via {
  width: 4%;
  min-width: 60px;
}

.applicant-table-header .col-scout {
  width: 7%;
  min-width: 85px;
}

.applicant-table-header .col-name {
  width: 12%;
  min-width: 170px;
}

.applicant-table-header .col-age {
  width: 3%;
  min-width: 100px;
  white-space: nowrap;
}

.applicant-table-header .col-graduation {
  width: 10%;
  min-width: 150px;
}

.applicant-table-header .col-company {
  width: 9%;
  min-width: 135px;
}

.applicant-table-header .col-job {
  width: 11%;
  min-width: 150px;
}

.applicant-table-header .col-income {
  width: 6%;
  min-width: 95px;
  white-space: nowrap;
}

.applicant-table-header .col-memo {
  width: 7%;
  min-width: 105px;
}

.applicant-table-header .col-status {
  width: 12%;
  min-width: 140px;
}

/* Media query for smaller screens (up to 1440px) */
@media (max-width: 1440px) {
  .applicant-table-header .col-review-date {
    width: 7%;
    min-width: 95px;
  }

  .applicant-table-header .col-joined-date {
    width: 7%;
    min-width: 130px;
  }

  .applicant-table-header .col-via {
    width: 4%;
    min-width: 55px;
  }

  .applicant-table-header .col-scout {
    width: 6%;
    min-width: 80px;
  }

  .applicant-table-header .col-name {
    width: 14%;
    min-width: 165px;
  }

  .applicant-table-header .col-age {
    width: 3%;
    min-width: 85px;
  }

  .applicant-table-header .col-graduation {
    width: 10%;
    min-width: 125px;
  }

  .applicant-table-header .col-company {
    width: 10%;
    min-width: 125px;
  }

  .applicant-table-header .col-job {
    width: 11%;
    min-width: 125px;
  }

  .applicant-table-header .col-income {
    width: 6%;
    min-width: 85px;
  }

  .applicant-table-header .col-memo {
    width: 7%;
    min-width: 95px;
  }

  .applicant-table-header .col-status {
    width: 9%;
    min-width: 125px;
  }

  /* Ensure text stays on one line for columns with arrows */
  .applicant-table-header .col-joined-date,
  .applicant-table-header .col-age,
  .applicant-table-header .col-income {
    white-space: nowrap;
    font-size: 13px;
  }

  .applicant-table-header .arrow-link i {
    font-size: 11px;
    display: inline-block;
    vertical-align: middle;
  }
}

/* Media query for extra small screens (up to 1366px) */
@media (max-width: 1366px) {
  .applicant-table-header .col-review-date {
    min-width: 90px;
    font-size: 12px;
  }

  .applicant-table-header .col-joined-date {
    min-width: 120px;
    font-size: 12px;
  }

  .applicant-table-header .col-via {
    min-width: 50px;
  }

  .applicant-table-header .col-scout {
    min-width: 75px;
  }

  .applicant-table-header .col-name {
    min-width: 160px;
    font-size: 14px;
  }

  .applicant-table-header .col-age {
    min-width: 80px;
    font-size: 12px;
  }

  .applicant-table-header .col-graduation {
    min-width: 120px;
  }

  .applicant-table-header .col-company {
    min-width: 120px;
  }

  .applicant-table-header .col-job {
    min-width: 120px;
  }

  .applicant-table-header .col-income {
    min-width: 85px;
    font-size: 12px;
  }

  .applicant-table-header .col-memo {
    min-width: 95px;
  }

  .applicant-table-header .col-status {
    min-width: 120px;
    font-size: 12px;
  }

  /* Smaller arrows */
  .applicant-table-header .arrow-link i {
    font-size: 10px;
    margin: 0 0.5px;
  }

  /* Allow text wrapping in less critical columns */
  .applicant-table-header .col-graduation,
  .applicant-table-header .col-company,
  .applicant-table-header .col-job {
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }
}

/* When review list date is hidden, redistribute the width */
.applicant-table-header:not(.has-review-date) .col-joined-date {
  width: 9%;
}

.applicant-table-header:not(.has-review-date) .col-via {
  width: 4%;
}

.applicant-table-header:not(.has-review-date) .col-scout {
  width: 7%;
}

.applicant-table-header:not(.has-review-date) .col-name {
  width: 15%;
}

.applicant-table-header:not(.has-review-date) .col-graduation {
  width: 10%;
}

.applicant-table-header:not(.has-review-date) .col-company {
  width: 10%;
}

.applicant-table-header:not(.has-review-date) .col-job {
  width: 11%;
}

.applicant-table-header:not(.has-review-date) .col-memo {
  width: 8%;
}

.applicant-table-header:not(.has-review-date) .col-status {
  width: 12%;
}

/* Hide review date column when not shown */
.applicant-table-header:not(.has-review-date) .col-review-date {
  display: none;
}

/* Header specific styles */
.client-listing-detail table th a {
  color: #016d6b;
  font-size: 12px;
  text-decoration: none !important;
}

.arrow-link i {
  color: #d0c2c2;
}

.arrow-link i.active {
    color: #016d6b;
}

th.arrow-link:hover {
  cursor: pointer;
}

.btn-sm-drop {
  /* padding: 5px; */
  font-size: 14px;
}

.th-dropdown-text {
  display: inline-block;
  min-width: 180px;
}

.th-dropdown >>> .btn {
  color: #026c6c !important;
  font-size: 14px !important;
}

.status-dropdown-menu {
  min-width: 180px !important;
}

/* Table header text color */
th {
  color: #016d6b !important;
}

.dropdown-separator {
  border-top: 1px solid #e6e8ec;
  margin: 10px 0;
}

.dropdown-footer {
  display: flex;
  justify-content: center;
  padding: 3px 0 1px 0;
}

.ok-button {
  background-color: #62a4fd !important;
  border-color: #62a4fd !important;
  padding: 3px 18px;
  font-size: 13px;
  border-radius: 4px !important;
}

.ok-button:hover {
  background-color: #4a8ee4 !important;
  border-color: #4a8ee4 !important;
}
</style>